import { Footer } from './component';
import { enhance } from './enhancers';

export default enhance(Footer);
